import type { ModalBackdropProps } from './modal.types'

import { styled, useStyleConfig, vui } from '../core'
import { colors } from '../theme'
import { cs, HSLToRGBA, parseHSL } from '../utils'
import { useModalContext } from './context'

const { h, s, l } = parseHSL(colors.sandstone[5])
const rgba = HSLToRGBA(h, s, l, 0.6)

export const ModalBackdropBase = styled.divBox`
  background-color: ${rgba};
  inset: 0;
  position: fixed;
  z-index: 1399;
`

/** Displays a dark overlay underneath modal content, but on top of page content. */
export const ModalBackdrop = vui<'div', ModalBackdropProps>((props, ref) => {
  const { className, ...rest } = props
  const context = useModalContext()
  const styles = useStyleConfig('Modal', context)

  return (
    <ModalBackdropBase
      animation="fadeIn"
      className={cs('vui-modalBackdrop', className)}
      style={{ zIndex: context.backdropZIndex ?? 1399 }}
      ref={ref}
      {...styles.backdrop}
      {...rest}
    />
  )
})

ModalBackdrop.displayName = 'ModalBackdrop'

export default ModalBackdrop
